import { CUSTOMER_JOURNEY_VENUES_ERROR } from './../const';

function action() {
  return { type: CUSTOMER_JOURNEY_VENUES_ERROR };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyVenuesError.js